//#region src/logic/phoneLoginOutcome.ts
var e = (e, t) => e.mfa_required && e.mfa_token ? {
	kind: "mfa",
	mfaToken: e.mfa_token
} : e.deletion_pending && e.restore_token ? {
	kind: "restore",
	restoreToken: e.restore_token,
	scheduledFor: e.deletion_scheduled_for ?? null
} : e.user ? e.passkey_enrollment_token && t ? {
	kind: "offerPasskey",
	enrollmentToken: e.passkey_enrollment_token
} : { kind: "signedIn" } : { kind: "unresolved" }, t = (e, t) => e.verification_token ? e.passkey_enrollment_token && t ? {
	kind: "offerPasskey",
	verificationToken: e.verification_token,
	enrollmentToken: e.passkey_enrollment_token
} : {
	kind: "complete",
	verificationToken: e.verification_token
} : { kind: "unresolved" };
//#endregion
export { e as resolvePhoneLoginOutcome, t as resolvePhoneRegistrationOutcome };
